/** A copy is exported; the source library file and its content revision stay intact. */
export function downloadPdfInk(blob:Blob,name:string):void{
 const url=URL.createObjectURL(blob),anchor=document.createElement('a');
 anchor.href=url;anchor.download=name;anchor.style.display='none';document.body.append(anchor);anchor.click();anchor.remove();
 // Safari must be allowed to consume the click before the object URL is released.
 window.setTimeout(()=>URL.revokeObjectURL(url),60_000);
}

export function annotatedPdfName(name:string):string{return `${name.replace(/\.pdf$/i,'')}-批注.pdf`;}

export async function verifyPdfInkSource(bytes:Uint8Array,contentRevision:string):Promise<void>{
 const digest=await crypto.subtle.digest('SHA-256',new Uint8Array(bytes));
 const actual=Array.from(new Uint8Array(digest),value=>value.toString(16).padStart(2,'0')).join('');
 if(actual!==contentRevision)throw new Error('PDF 内容已经更新，请刷新资料库后再书写。已有笔迹仍保留在原版本。');
}
